// Profile stats derived CLIENT-side from my matches (spec/usersmatch/05):
// Partidos = matches with a recorded result; Racha = consecutive Mon–Sun
// weeks with ≥1 played match, counting back from the current week — an
// empty CURRENT week doesn't break the streak (it isn't over until a full
// week passes without playing). Local time approximates Europe/Madrid: the
// launch market is Spain-only, and a week boundary off by tz hours can only
// misplace a match played within ±2h of Sunday midnight.

export interface PlayedMatchLike {
  /** yyyy-mm-dd of the match day. */
  dateISO: string
  hasResult: boolean
  upcoming: boolean
}

export interface PlayerStats {
  matches: number
  streak: number
  upcoming: number
}

/** Monday 00:00 of the week containing `d` (local time). */
function mondayOf(d: Date): Date {
  const x = new Date(d)
  x.setHours(0, 0, 0, 0)
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7))
  return x
}

export function computePlayerStats(matches: PlayedMatchLike[], now: Date): PlayerStats {
  const played = matches.filter((m) => m.hasResult)
  const weeks = new Set(played.map((m) => mondayOf(new Date(`${m.dateISO}T12:00:00`)).getTime()))

  // Walk back week by week via setDate (calendar days — DST-safe, unlike
  // fixed-milliseconds arithmetic which drifts an hour across changes).
  const cursor = mondayOf(now)
  let streak = 0
  if (!weeks.has(cursor.getTime())) cursor.setDate(cursor.getDate() - 7)
  while (weeks.has(cursor.getTime())) {
    streak++
    cursor.setDate(cursor.getDate() - 7)
  }

  return {
    matches: played.length,
    streak,
    upcoming: matches.filter((m) => m.upcoming).length,
  }
}
